import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { DocumentCheckIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline'

export default function Modal({ toggleModal, message, successCount, updatedCount, preImportNew, preImportExisting }) {
  console.log('📱 Modal component received props:', { message, successCount, updatedCount, preImportNew, preImportExisting });
  const [open, setOpen] = useState(true);

  const handleModal = () =>{
    setOpen(false);
    toggleModal();
  } 

  return (
    <Dialog open={open} onClose={handleModal} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="sm:flex sm:items-start">
                <div className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full ${message === "Success"? "bg-green-100" :"bg-orange-100"} sm:mx-0 sm:h-10 sm:w-10`}>
                  {message === "Success" ? <DocumentCheckIcon aria-hidden="true" className={`h-6 w-6 text-green-600 `} /> : 
                  <ExclamationTriangleIcon aria-hidden="true" className={`h-6 w-6 text-orange-600 `} />
                }
                </div>
                <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <DialogTitle as="h3" className="text-base font-semibold leading-6 text-gray-900">
                    {
                      (message === "Success") ? "Data Import Complete!" : "Data Import Failed!"
                    }
                  </DialogTitle>
                  <div className="mt-2">
                  <div className="text-sm text-gray-500">
                    {message === "Success" ? (
                      <>
                        Successfully imported the contact and company records from the uploaded CSV file to HubSpot.
                        
                        {/* Import Results */}
                        {(preImportNew !== null || preImportExisting !== null) && (
                          <div className="mt-3 p-3 bg-green-50 rounded-lg border border-green-200">
                            <h4 className="font-semibold text-green-800 mb-2">Import Results:</h4>
                            <div className="text-sm text-green-700">
                              <div className="flex justify-between">
                                <span>New Contacts:</span>
                                <span className="font-semibold">{preImportNew || 0}</span>
                              </div>
                              <div className="flex justify-between">
                                <span>Updated Contacts:</span>
                                <span className="font-semibold">{preImportExisting || 0}</span>
                              </div>
                            </div>
                          </div>
                        )}
                        
                        <strong> To import another file, please click Reload.</strong>
                      </>
                    ) : (
                      "The contact and company records was not imported. Try Again."
                    )}
                  </div>

                  </div>
                </div>
              </div>
            </div>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                onClick={() => window.location.reload()}
                className={`inline-flex w-full justify-center rounded-md  px-3 py-2 text-sm font-semibold text-white shadow-sm  sm:ml-3 sm:w-auto ${message === "Success" ? "hover:bg-green-600 bg-green-700" : "hover:bg-hs-orange-light bg-hs-orange"}`}
              >
                Reload
              </button>
              <button
                type="button"
                data-autofocus
                onClick={handleModal}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Close
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  )
}